import { SVGProps } from 'react'

interface IconProps extends SVGProps<SVGSVGElement> {
  id: string
  label?: string
}

export default function IconSprite({ id, ...props }: IconProps) {
  return (
    <span role="img" aria-label={props.label}>
      <svg {...props}>
        <use href={`/assets/icons/sprite.svg#${id}`} />
      </svg>
    </span>
  )
}